import {defineMessages} from 'react-intl';

export const teamCallMessages = defineMessages({
    selected: {id: 'callSurface.team.selected', defaultMessage: '{count} selected'},
    call: {id: 'callSurface.team.call', defaultMessage: 'Call'},
    video: {id: 'callSurface.team.video', defaultMessage: 'Video'},
    clear: {id: 'callSurface.team.clear', defaultMessage: 'Clear selection'},
    selectPerson: {id: 'callSurface.team.select-person', defaultMessage: 'Select {name}'},
    toolbar: {id: 'callSurface.team.toolbar', defaultMessage: 'Selected people'},
    failed: {id: 'callSurface.team.failed', defaultMessage: 'Couldn’t start the group call. Try again.'},
});
